import React, {ReactElement, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {
  HOME_ROUTE_PATH,
  LANDING_PATH,
  LOGIN_ROUTE_PATH,
} from '../../../routes/route-constants';
import home from '../../../assets/images/home.svg';
import {Link} from 'react-router-dom';
import {pageName, socialLinksContacUs} from '../../../lib/constants';
import {
  getPaymentonfirm,
  getThankyou,
  getUserType,
} from '../../../core/localstorage-data';
import {setPageName} from '../../../lib/tagmanager';
import MidScreenModal from '../../../components/modal/MidScreenModal';
import RateUs from './RateUs';
type ThankYouProps = {
  onRedIconClick: () => void;
  type: string | null;
};
const ThankYou: React.FC<ThankYouProps> = ({
  onRedIconClick,
  type,
}: ThankYouProps): ReactElement => {
  const navigate = useHistory();
  const [rateUsModal, setRateusModal] = useState(false);

  const paymentStatus = getPaymentonfirm();
  const thankyou = getThankyou();
  //TODO:
  //get this from localStorage
  const userType = getUserType();
  if (userType === null) {
    ///  navigate.replace('/employeesignin');
    window.location.href = 'employeesignin';
  }
  const nextCustomerHandler = () => {
    localStorage.clear();
    window.location.href = 'employeesignin';
  };
  useEffect(() => {
    setPageName(pageName.thankyoupage);
    if (type === null) {
      setTimeout(() => {
        setRateusModal(true);
      }, 5000);
    }
  }, []);
  const buttonHandler = () => {
    navigate.push(HOME_ROUTE_PATH);
  };
  function handleOnGreenClick() {
    setRateusModal(false);
  }
  function handleOnRedClick() {
    setRateusModal(false);
    onRedIconClick();
  }
  return (
    <div className="container mx-auto z-10 px-8 bg-color">
      <div className="w-auto ">
        <div className="mt-8 grid place-items-center">
          <svg
            className="w-20 h-20 text-white rounded-full bg-green_zero "
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
              d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <div className="mt-6 grid place-items-center">
          <span className="font-roboto text-big font-light text-center">
            Thank you!
          </span>
        </div>
        <div className="mt-6 grid text-center text-black text-opacity-50">
          {userType === 'employee' && paymentStatus === 'true' && (
            <div>
              Your order has been pushed to POS. Kindly make the payment at any
              cash counter to collect the order.
            </div>
          )}
          {userType === 'employee' && thankyou === 'true' && (
            <div>Thank you for shopping with MAX. Have a great day!</div>
          )}
          {userType !== 'employee' && type === null && (
            <div> Thank you for shopping with MAX. Have a great day!</div>
          )}
          {userType !== 'employee' && type !== null && type === 'default' && (
            <div> Thank you for shopping with MAX. Have a great day!</div>
          )}
          {userType !== 'employee' && type !== null && type === 'connect' && (
            <div>
              Thank you for shopping with MAX. We will get in touch with you.
              Have a great day!
            </div>
          )}
        </div>
        <div>
          {userType !== 'employee' ? (
            <div className="follow mt-40 flex flex-col">
              <div className="font-rooto text-xl text-center mb-6">
                Follow us
              </div>
              <div className="flex mx-auto justify-around w-3/6">
                {socialLinksContacUs.map((socialLink, index) => {
                  return (
                    <div key={index} className="mx-2">
                      <Link
                        to={{pathname: `${socialLink.link}`}}
                        target="_blank">
                        <img src={socialLink.icon} alt={socialLink.type} />
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
        <div>
          {userType !== 'employee' ? (
            <div className="mt-6">
              <div className="flex justify-between">
                <button
                  className="text-white h-12 px-3 w-full rounded-radius10 border-solid border border-gray-400 grid place-items-center focus:outline-none text-center font-medium
                secondary normal"
                  onClick={buttonHandler}>
                  <div className="flex">
                    <div>
                      <img src={home} />
                    </div>
                    <div className="ml-2">
                      {' '}
                      <span className="text-roboto text-black">Home</span>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          ) : (
            <div className="mt-60">
              <button
                className="text-white h-12 px-3 w-full rounded-radius10 border-solid border border-gray-400 grid place-items-center focus:outline-none text-center font-medium
                secondary normal"
                onClick={nextCustomerHandler}>
                <div className="ml-2">
                  {' '}
                  <span className="text-roboto text-black">Next customer</span>
                </div>
              </button>
            </div>
          )}
        </div>
      </div>
      <MidScreenModal
        isVisible={rateUsModal}
        onClose={() => {
          setRateusModal(false);
        }}>
        <RateUs
          onGreenClick={handleOnGreenClick}
          onRedClick={handleOnRedClick}
        />
      </MidScreenModal>
    </div>
  );
};
export default ThankYou;
